<div appHeightWatcher>
  @for (array of participantIdToPrepEvents | keyvalue; track array) {
  <div>
    <b>{{participantIdToParticipantname.get(array.key)}}</b>
    <ul class="list-group">
      @for (event of array.value; track event) {
      <li class="list-group-item">
        <span>{{ timeblockIdToTimeblockname.get(event.tbid)}} ({{event.start.split(':').splice(0, 2).join(':')}}
          Uhr
          bis {{event.end.split(':').splice(0, 2).join(':')}} Uhr) </span>
        <ui-switch
          #switch
          id="switch"
          class="float-right"
          [checked]="prepEntryMap.has(event.id + '' + array.key) && compareDate(prepEntryMap.get(event.id + '' + array.key).end)"
          (change)="switchChanged($event, array.key, event.id)"
        ></ui-switch>
        <label
          class="float-right"
          style="margin-top: 0.5%; margin-right: 1%"
          i18n="@@prepLockLabel"
          for="switch"
        >Sperre</label>
        @if (prepEntryMap.has(event.id + '' + array.key)) {
        <span
          class="badge badge-pill badge-info prepTimeBadge"
          [ngClass]="{'badge-danger': switch.checked}"
          i18n="@@prepTimeUntil"
        > Vorbereitungszeit bis {{prepEntryMap.get(event.id + '' + array.key).end | date: 'HH:mm'}}Uhr</span>
        }
        @if (!prepEntryMap.has(event.id + '' + array.key)) {
        <span
          class="badge badge-pill badge-info prepTimeBadge"
          i18n="@@prepTimeNotStarted"
        > Vorbereitungszeit noch nicht begonnen</span>
        }
      </li>
      }
    </ul>
    <br>
    <br>
  </div>
  }
</div>